import React, {FC, MouseEvent, useEffect, useRef, useState}  from 'react';

// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper,
   TextField, MenuItem, CircularProgress, IconButton, Popper, ClickAwayListener, Grow, ListItemText, MenuList, ListItemIcon} from '@mui/material';
import {LockOutlined} from '@mui/icons-material';

import {Language as LanguageIcon, TranslateOutlined as TranslateOutlinedIcon } from '@mui/icons-material';

import Loader, { ThreeDots } from "react-loader-spinner";

// import library.
import { useForm } from 'react-hook-form';
import {useQuery,useQueryClient, QueryClient, QueryClientProvider, useMutation, } from "react-query";
import md5 from 'md5';
import {useLocalStorage} from 'react-use';
//import '../library/i18n';
import { useSnackbar } from 'notistack';
import { useTranslation  } from 'react-i18next';
import {availableLanguages} from '../library/i18n';

import { isNumber, toNumber } from 'lodash';
// import user Component


// import user Library.
import useAxios from '../library/axios';
import {User, UserCredential, UserCredentialMd5} from '../component/security/User'
import {useUserStore} from '../library/store';


interface BankCustomer {
  customerID: number;
  personNameNIC: string;
}

type Params = {
  queryKey: [string, { id: number }];
};




function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.univsoft.com/">
        
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}




// const getEmployee = async () => {
//   const { data } = await axios.get('http://dummy.restapiexample.com');
//   return data.data;
//   };
  
const Login: FC<UserCredential> = () => {

  const { register, getValues, setValue ,formState: { errors } } = useForm<UserCredential>({defaultValues: {language:'fr'}});

  const axios = useAxios();

  const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

  const [ storeCustomerID, setStoreCustomerID ,  removeStoreCustomerID]  = useLocalStorage('CustomerID');
  const [ storeLanguage, setStoreLanguage ,  removeStoreLanguage]  = useLocalStorage('Language');
  const [ storeLogin, setStoreLogin, removeStoreLogin  ] = useLocalStorage('Login');

  // const setCurrentUser = useUserStore(state => state.setCurrentUser);

  const anchorRefLanguageButton = useRef(null);
  const [openLanguageMenu, setOpenLanguageMenu] = useState(false);

  const [bgIndex, setBgIndex] = useState<number>(1);

  const inputLogin = useRef();
  const inputPassword = useRef();

  const {setCurrentUser} = useUserStore();

  const postCredential = async (md5Credential: UserCredentialMd5) => 
  await (await axios.post('/security/user/validateUser', md5Credential)).data;

  const getBankUserCustomer = async () => {
    const {data} = (await axios.get('/crm/bankUser/getBankUserCustomer'));
    return await data;
  }

  const {isLoading, isError, isSuccess ,error,mutate} = useMutation<User,Error,UserCredentialMd5>(postCredential,
     {
       retry:2,
       onSuccess: (data: User) => {
        try {
          
          if(!data.isConnected) {
            enqueueSnackbar( t('Invalid user credential'), { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
          }
          
          setCurrentUser(data);
          // const {isConnected} = data;
          // if(isConnected) 
          //   connectUser();

        } catch {

        }
       }
    });

  const [bankCustomers, setBankCustomers] = useState<BankCustomer[]>([]);
  // const {isSuccess: isBankCustomerSuccess ,status: BankCustomerStatus,data: bankCustomers} = 
  //     useQuery<BankCustomer[]>(["bankCustomer", { id: 1 }],getBankUserCustomer);

    const onClickLanguageMenu = () => {
      setOpenLanguageMenu(true);
  
    };
  
    const menuLanguageItemClick = (lg: string) => (event: any) =>{
      i18n.changeLanguage(lg);
      setOpenLanguageMenu(false);
      setStoreLanguage(lg);
      setValue('language', lg);

      // console.log(i18n);
      // console.log(i18n.getResource('fr','common','Signin'));
      //localStorage.setItem('lastLanguage', lg);
    }
  
    const closeLanguageMenu = () => {
      setOpenLanguageMenu(false);
    };

    // useEffect( () => {        
    //   async function loadBankUserCustomer() {
        
    //       const arr = await getBankUserCustomer();         
    //       setBankCustomers([...arr]);          
    //   }
     

    //   loadBankUserCustomer();
    // }, []); 


  const postLogin = async (event: MouseEvent<HTMLButtonElement>) => {
    
    event.preventDefault();
    
    const  {login, password, language ,externalCustomerID} = getValues();

    const {hostname, host} = window.location;

    const tempCustomerID = window.location.search.replace('?','');


    //if( !isNumber(tempCustomerID) ) {
    if(  isNaN(Number(tempCustomerID)) ) {
      enqueueSnackbar( t('The url is invalid, you have to add ?xxxx at the of url'), { variant: 'error',
          anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });

      const tenant = 'xxxx';
      window.location.replace(`${host}?${tenant}`);
      return;
    }

    // if( externalCustomerID && externalCustomerID <= 0) {
    //   alert('invalid banque ...');
    //   return;
    // }

    setStoreCustomerID(toNumber(tempCustomerID));
    //setStoreCustomerID(externalCustomerID);
    
    // console.log(login);
    // console.log(password);
    // console.log(getValues());
    // console.log(md5(password));

    //console.log({ login, password: md5(password), externalCustomerID: toNumber(tempCustomerID) , language: language.startsWith('fr')?'fr-FR':'en-US' });

     mutate({ login, password: md5(password), externalCustomerID: toNumber(tempCustomerID) , language: language.startsWith('fr')?'fr-FR':'en-US' } as UserCredentialMd5);

    //console.log(data);
    //event.preventDefault();
    //const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    // console.log({
    //   email: data.get('email'),
    //   password: data.get('password'),
    // });
  };


  const COUNT_BG_IMAGES = 10;
  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex( Math.floor(Math.random()* COUNT_BG_IMAGES ) + 1 );
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // if(isBankCustomerSuccess)
  //   console.log(bankCustomers);

  // console.log(BankCustomerStatus);


  // if(isSuccess) {
  //   // console.log(data);
    
  //   connectUser();  
  //   return(<></>);
  // } else

    

    return (
      
      <Grid container component="main" sx={{ height: '100vh', 
                    //backgroundImage: 'url(https://source.unsplash.com/random)',
                    backgroundImage: `url(/images/${bgIndex}.jpg)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: (t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                    backgroundSize: 'cover',
                    backgroundPosition: 'center', }}
        >
        <Grid item xs={1} sm={6} md={8}></Grid>
        
        <Grid item xs={10} sm={5} md={3} component={Paper} elevation={0} square>
          <Box sx={{ my: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent:'center', width: '100%' }} >
            <Box sx={{ mt: 1, width: '100%'  }} > 
              <IconButton ref={anchorRefLanguageButton} aria-label="account of current user" aria-controls="menu-appbar"
                  aria-haspopup="true"onClick={onClickLanguageMenu} color="inherit" >
                  <LanguageIcon />
              </IconButton>
              <Popper open={openLanguageMenu} anchorEl={anchorRefLanguageButton.current} role={undefined} transition >
                {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={closeLanguageMenu}>
                      <MenuList dense={true} id="menu-list-grow">  
                      {(i18n.language !== 'fr') && 
                        <MenuItem onClick={menuLanguageItemClick("fr")}>
                          <ListItemIcon>
                            <TranslateOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="Francais" />                              
                        </MenuItem> }
                        {(i18n.language !== 'en') && 
                        <MenuItem onClick={menuLanguageItemClick("en")}>
                          <ListItemIcon>
                            <TranslateOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="English" />
                      </MenuItem> }                         
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
                )}
              </Popper>
            </Box>
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlined />
            </Avatar>
            <Typography component="h1" variant="h5">
              {t('Signin')}
            </Typography>
            <Box sx={{ mt: 1, width: '100%'}}>
              <TextField sx={{width:'calc(100% - 8px)'}} required  id="email" label={t('Login')} {...register('login')} defaultValue={ (storeLogin || '') as string}
                inputRef={inputLogin} inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } } autoFocus 
                InputProps={{
                  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                    if(event.key === 'Enter' && inputPassword.current)
                      (inputPassword.current as HTMLInputElement).focus();
                  },
                }}
              />
              <TextField sx={{width:'calc(100% - 8px)'}} required label={t('Password')} {...register('password')}
                type="password" id="password" autoComplete="current-password" inputRef={inputPassword}
                InputProps={{
                  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                    if(event.key === 'Enter') {
                      const btnPostLogin = document.getElementById(`btnPostLogin`);
                      if(btnPostLogin !== null)
                        btnPostLogin?.click();                        
                    }
                      //postLogin( new MouseEvent<HTMLButtonElement,MouseEvent>('button') );
                  },
                }} />
              {/* <TextField sx={{width:'calc(100% - 8px)'}} required  id="select" label={t('Partner')} {...register('externalCustomerID')} defaultValue={ (storeCustomerID || 0) as number} select>
                <MenuItem  value={0}>{''}</MenuItem>
                 {bankCustomers && bankCustomers.map( 
                   (bc,icx) => <MenuItem key={bc.customerID} value={bc.customerID}>{bc.personNameNIC}</MenuItem> )
                 }
              </TextField> */}
              
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} onClick={postLogin} id="btnPostLogin">
                {isLoading ? <ThreeDots 
                        color='#00BFFF'
                        height={'100%'}
                        //width={100}
                        //timeout={3000} //3 secs
                      /> : t('Signin')}
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                   
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {isError? "Error" : ""}
                  </Link>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    
    );
  }
  
  export default Login;